import React from 'react'
import styled from 'styled-components'
import { styled as muiStyled } from '@mui/material/styles';

import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';

const Container = styled.div`
    margin: ${props => props.styles.margin};
    padding: ${props => props.styles.padding};
    width: ${props => props.styles.width};
`

const Label = styled.div`
    font-size: 0.8rem;
    margin: 0.2rem 0;
    /* transform: ${props => `translateX(${props.value.toFixed(0)}%)`}; */
    :after {
        content: '%'
    }
`

const defaultStyle = {
    margin: 0,
    padding: '0.5rem',
    width: '100%'
}

const CustomLinearProgress = muiStyled(({ className, ...props }) => {
    return (
        <div style={{overflow: 'hidden'}}>
            <LinearProgress className={className} {...props} color='primary'/>
            {props.showLabel && <Label value={props.value}>{props.value.toFixed(0)}</Label>}
        </div>
    )
})(({ theme }) => ({
    backgroundColor:'var(--secondary-color)', 
    borderRadius: '5px',
    // [`& .${linearProgressClasses.colorPrimary}`]: {backgroundColor:'var(--focus-color)'},
    [`& .${linearProgressClasses.colorSecondary}`]: {},
    [`& .${linearProgressClasses.determinate}`]: {
        backgroundColor:'var(--focus-color)',
    },
    [`& .${linearProgressClasses.indeterminate}`]: {backgroundColor:'var(--focus-color)'},
    [`& .${linearProgressClasses.bar}`]: {
        backgroundColor:'var(--focus-color)',
        borderRadius: '5px'
    },
    // [`& .${linearProgressClasses.barColorPrimary}`]: {},
    // [`& .${linearProgressClasses.barColorSecondary}`]: {},
    // [`& .${linearProgressClasses.bar1Indeterminate}`]: {
    //     backgroundColor:'var(--focus-color)',
    //     borderRadius: '5px'
    // },
    // [`& .${linearProgressClasses.bar2Indeterminate}`]: {backgroundColor:'var(--focus-color)'},
    // [`& .${linearProgressClasses.bar1Determinate}`]: {}
}));

const ProgressBar = props => {
    const {
        value,
        variant = 'indeterminate',
        styles,
        showLabel = false
    } = props;
    const updatedStyle = Object.assign({}, defaultStyle, styles)
    return (
        <Container styles={updatedStyle}>
            <CustomLinearProgress variant={value !== undefined ? 'determinate' : variant} value={value} showLabel={showLabel}/>
        </Container>
    )
}

export default ProgressBar